//@flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Image } from 'components/atoms/image';
import type { Vertical } from 'types/common';
import { StringUtil } from 'utils/StringUtil';
import { NavigationUtil } from 'utils/NavigationUtil';
import { HTMLView } from 'components/atoms/htmlView';
import { RouteUtil } from 'utils/RouteUtil';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Vertical,
  history: Object,
  onPress: () => void,
};

const MainMenuVerticalCard = (props: Props) => {
  const { data, onPress } = props;
  const imageUrl = data.imageUrl;
  const thumbnailUrl = data.thumbnailUrl;

  const handleClick = (pathName, id) => {
    if (pathName.includes('Portfolio in India')) {
      window.location.href = 'https://www.total-environment.com/homes'; 
      return;
    }
    let name = StringUtil.sliceHtml(pathName);
    const routeName = NavigationUtil.getRouteForVertical(name);
    const pathname = props.history.location.pathname;
    // checks whether the current path and clicked verticals are same ,
    // if then passes a prop to MainMenu to close the MainMenu overlay.
    if (pathname === routeName) onPress();
    RouteUtil.setRouteChange(props, data.route);
  };

  return (
    <div
      className={'vertical-container'}
      onClick={() => handleClick(data.name, data.id)}
    >
      <div className={'image-container'} />
      <Image
        className={'image'}
        thumbNail={thumbnailUrl}
        src={imageUrl}
        alt={data.name}
        isHoveredImagePresent={true}
      />
      <HTMLView className={'vertical-name'} html={data.name} tagName={'div'} />
      <HTMLView
        className={'vertical-description'}
        html={data.description}
        tagName={'div'}
      />
    </div>
  );
};
export default withRouter(MainMenuVerticalCard);
